export default __webpack_public_path__ + "src/images/galleries/0/btn_lan_en-827642.png";